import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { ButtonBase } from '@mui/material';
import classNames from 'classnames';
import css from './RecentChatsSection.module.scss';

interface Props {
  label: string;
  collapsed: boolean;
  onToggle: () => void;
}

/**
 * A chat-group header ("Starred" / "Recents") that doubles as a collapse/expand
 * toggle. Rendered as an MUI `ButtonBase` (ripple disabled) so the resting look is
 * identical to the old static header — the chevron only fades in on hover, and
 * stays visible (rotated to point right) while the group is collapsed to signal
 * there's hidden content.
 */
export function ChatSectionHeader({ label, collapsed, onToggle }: Props) {
  return (
    <ButtonBase disableRipple className={css.header} onClick={onToggle} aria-expanded={!collapsed}>
      <span>{label}</span>
      <ExpandMoreIcon className={classNames(css.chevron, collapsed && css.chevronCollapsed)} />
    </ButtonBase>
  );
}
